// extracted by mini-css-extract-plugin
export var label = "_rf-0";
export var link = "_rf-1";